/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import { type ATTRIBUTE_DESCRIPTOR_TYPES } from 'embercom/models/custom-objects/constants/attribute-descriptor-types';
import type Attribute from 'embercom/models/attribute';

export type IntercomFieldType = 'conversation' | 'user' | 'company';

export default class ExternalFieldIdentifier extends Model {
  @attr('boolean') declare builtIn: boolean;
  @attr('string') declare externalId: string;
  @attr('string') declare intercomAttributeIdentifier: string;
  @attr('string') declare intercomDataType: ATTRIBUTE_DESCRIPTOR_TYPES;
  @attr('string') declare intercomFieldType: IntercomFieldType;
  @attr('string') declare name: string;
  @attr('boolean') declare suitableForIdentityMapping: boolean;
  @attr('boolean') declare synchronized: boolean;

  @attr('boolean') declare isSynchronizing?: boolean;

  get attributeModel(): Attribute | undefined {
    if (!this.intercomAttributeIdentifier) {
      return;
    }

    if (this.intercomFieldType === 'user' || this.intercomFieldType === 'company') {
      return this.store.peekAll('attribute').findBy('identifier', this.intercomAttributeIdentifier);
    }

    return;
  }

  get intercomCdaIdentifier() {
    if (!this.attributeModel?.isCustomData) {
      return;
    }
    return this.attributeModel?.identifier;
  }

  get intercomSdaIdentifier() {
    if (this.attributeModel?.isCustomData) {
      return;
    }
    return this.attributeModel?.identifier;
  }

  get description() {
    return this.attributeModel?.description;
  }

  get type() {
    return this.intercomDataType;
  }
}
